import {
  ClientConfigurationError,
  InteractionRequiredAuthError,
  InteractionStatus,
  InteractionType,
} from '@azure/msal-browser';
import { useMsal, useMsalAuthentication } from '@azure/msal-react';
import { useEffect } from 'react';

import { ECM_SCOPES } from '@/config/EnviromentConfig';
import { msalSettings } from '@/config/MsalAuthConfig';
import { isNativeWebview } from '@/config/nativeTokenStore';

export const usePrivateRoute = () => {
  // const navigate = useNavigate();
  const { login, error } = useMsalAuthentication(InteractionType.Silent, {
    scopes: ECM_SCOPES,
    authority: msalSettings.authorities.signUpSignIn,
  });
  const { inProgress, accounts } = useMsal();

  useEffect(() => {
    if (!error) {
      return;
    }
    if (!(error instanceof InteractionRequiredAuthError || error instanceof ClientConfigurationError)) {
      return;
    }
    // Wait for any in-progress interactions to complete before redirecting
    if (inProgress !== InteractionStatus.None) {
      return;
    }

    if (!isNativeWebview()) {
      login(InteractionType.Redirect);
    }
  }, [error, inProgress, login]);

  useEffect(() => {
    if (error) {
      // Only log and navigate if it's not an interaction_in_progress error
      if (error.errorCode !== 'interaction_in_progress') {
        if (!isNativeWebview()) {
          console.error('Authentication error:', error);
        }
        if (!isNativeWebview()) {
          login(InteractionType.Redirect);
        }
      }
      return;
    }

    // Check if user is authenticated by checking if there's an active account
    if (inProgress === InteractionStatus.None && accounts.length === 0) {
      // No authentication in progress and no accounts - redirect to login
      if (!isNativeWebview()) {
        login(InteractionType.Redirect);
      }
    }
  }, [error, inProgress, accounts, login]);

  return {
    isAuthenticated: accounts.length > 0,
    isLoading: inProgress !== InteractionStatus.None,
    error,
  };
};
